import styled from "styled-components";
import media from "styled-media-query";
import { isMobileSafari } from "react-device-detect";

export const PaginationWrapper = styled.section`
  display: flex;
  align-items: center;
  border-top: 1px solid var(--borders);
  color: var(--texts);
  padding: 1.5rem 3rem;
  justify-content: space-between;


  ${media.lessThan("large")`
    font-size: .8rem;
    padding: 1rem;
  `}

  a {
    color: var(--texts);
    text-decoration: none;
    transition: color 0.5s;
    &:hover {
      color: var(--highlight);
    }
  }

  ${isMobileSafari &&
    `
    padding-bottom: 100px !important;
  `}
`;
